import { ApiFetch } from '../../../shared/utils/fetch';
import type { ListPaymentsParams, ListPaymentsResponse, Payment } from '../types';

export const paymentsApi = {
  list: async (params?: ListPaymentsParams): Promise<ListPaymentsResponse> => {
    const entries = Object.entries(params ?? {}).filter(([, v]) => v !== undefined && v !== '');
    const qs = entries.length ? '?' + new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString() : '';
    const response = await ApiFetch.get<Payment[] | ListPaymentsResponse>(`/payments${qs}`);
    // payment-service returns the paginated envelope, but tolerate a bare array.
    if (Array.isArray(response)) {
      return { data: response, total: response.length, page: params?.page ?? 1, limit: params?.limit ?? 20 };
    }
    return response;
  },
};
